'use strict';

document.addEventListener( 'DOMContentLoaded', () => {
	let { links } = document;
	links = Array.prototype.slice.call( links );

	links.forEach( ( link ) => {
		if (
			( link.hostname !== window.location.hostname &&
				link.hostname !== 'www.gene.com' ) ||
			link.href.substr( link.href.length - 4 ) === '.pdf'
		) {
			// eslint-disable-next-line no-param-reassign
			link.target = '_blank';
			link.setAttribute( 'rel', 'noopener' );
			if ( ! link.getAttribute( 'data-ignore-external-link' ) ) {
				link.setAttribute( 'data-external-link', true );
			}
		}
	} );

	const externalLinks = document.querySelectorAll( '[data-external-link]' );

	externalLinks.forEach( ( externalLink ) => {
		const externalLinkNotification = document.createElement( 'span' );
		externalLinkNotification.classList.add( 'clip' );
		externalLinkNotification.innerHTML = ' (opens in new tab)';
		externalLink.appendChild( externalLinkNotification );
		externalLink.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			const linkDestination = externalLink.getAttribute( 'href' );
			const continueToSite = document.getElementById( 'continue-to-site' );
			continueToSite.target = '_blank';
			continueToSite.setAttribute( 'href', linkDestination );
			MicroModal.show( 'leaving-site-modal' );
		} );
	} );

	const closeModal = document.getElementById( 'close-modal' );

	closeModal.addEventListener( 'click', () => {
		MicroModal.close( 'leaving-site-modal' );
	} );

	const continueToSite = document.getElementById( 'continue-to-site' );

	continueToSite.addEventListener( 'click', () => {
		MicroModal.close( 'leaving-site-modal' );
	} );
} );
